import React, { useEffect, ReactNode } from "react";
import { useLayout } from "../../../theme/LayoutContext";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Helper from "../Helper/Helper";
import BreadcrumbHistory from "../BreadcrumbHistory/BreadcrumbHistory";
import Footer from "../../../layout/Footer";
import {
  getDashboardThemeClass,
  getHeaderThemeClass,
  getNavbarThemeVars,
} from "../../utils/theme";
import s from "./Layout.module.scss";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
import "font-awesome/css/font-awesome.min.css";
import "../../styles/shell.scss";

const MOBILE_MAX = 767.98;

interface SingLayoutProps {
  children?: ReactNode;
  logoutUser?: (() => void) | null;
}

function SingLayout({ children, logoutUser = null }: SingLayoutProps) {
  const {
    sidebarOpened,
    sidebarStatic,
    dashboardTheme,
    navbarColor,
    sidebarType,
    closeSidebar,
    changeActiveSidebarItem,
  } = useLayout();

  const navbarVars = getNavbarThemeVars(navbarColor);

  // Backdrop only matters as a drawer overlay on small screens (CSS also gates it)
  const showMobileBackdrop = sidebarOpened && !sidebarStatic;

  useEffect(() => {
    const syncBodyScroll = () => {
      const isMobile = window.innerWidth <= MOBILE_MAX;
      if (isMobile && sidebarOpened) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    };
    syncBodyScroll();
    window.addEventListener("resize", syncBodyScroll);
    return () => {
      window.removeEventListener("resize", syncBodyScroll);
      document.body.style.overflow = "";
    };
  }, [sidebarOpened]);

  const handleBackdropClick = () => {
    closeSidebar();
    changeActiveSidebarItem(null);
  };

  return (
    <div
      className={[
        s.root,
        sidebarStatic ? s.sidebarStatic : "",
        !sidebarOpened ? s.sidebarClose : "",
        "sing-dashboard",
        getDashboardThemeClass(dashboardTheme, sidebarType),
        getHeaderThemeClass(navbarColor),
      ]
        .filter(Boolean)
        .join(" ")}
      style={navbarVars as React.CSSProperties}
    >
      <Sidebar />
      {showMobileBackdrop ? (
        <button
          type="button"
          className={s.backdrop}
          aria-label="Close sidebar"
          onClick={handleBackdropClick}
        />
      ) : null}
      <div className={s.wrap}>
        <Header logoutUser={logoutUser} />
        <Helper />
        <main className={s.content}>
          <BreadcrumbHistory />
          <div className="sing-content-preserve content-wrapper retreats">
            {children}
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default SingLayout;
